// src/data/seoLocations.js
// Add / remove locations here — pages auto-generate from this list

export const SEO_LOCATIONS = [
  { name: "Rayasandra",        slug: "rayasandra",        nearby: "Electronic City, Begur" },
  { name: "Gattahalli",        slug: "gattahalli",        nearby: "Begur, Gottigere" },
  { name: "Naganathapura",     slug: "naganathapura",     nearby: "Electronic City, Hebbagodi" },
  { name: "Choodasandra",      slug: "choodasandra",      nearby: "Sarjapur Road, Bellandur" },
  { name: "Huskur",            slug: "huskur",            nearby: "Electronic City, Attibele" },
  { name: "Doddanamangala",    slug: "doddanamangala",    nearby: "Sarjapur, Dommasandra" },
  { name: "Chikkanagamangala", slug: "chikkanagamangala", nearby: "Attibele, Hebbagodi" },
];

// page types — each location gets all 5 variants = 35 pages total
export const SEO_PAGE_TYPES = [
  {
    type: "preschool",
    label: "Best Preschool",
    schemaType: "School",
    isPreschool: true,
    title:      (loc) => `Best Preschool in ${loc.name} | SeekersBay`,
    h1:         (loc) => `Best Preschool in ${loc.name}`,
    metaDesc:   (loc) => `SeekersBay is the best preschool in ${loc.name}, Bangalore. Rated 4.9/5 by parents. Enroll your child today for nurturing, play-based learning near ${loc.nearby}.`,
    keywords:   (loc) => `best preschool in ${loc.name}, preschool near ${loc.name}, top preschool ${loc.name} Bangalore, playschool ${loc.name}`,
    heroTag:    (loc) => `Ranked Bangalore's Top Preschool — Now Serving ${loc.name}`,
    heroSub:    (loc) => `Families in ${loc.name} and nearby ${loc.nearby} trust SeekersBay for exceptional early childhood education. Every smile, every 'aha' moment — we make learning extraordinary.`,
    ctaSection: (loc) => `Give Your Child the Best Start in ${loc.name}`,
    ctaSub:     (loc) => `Join hundreds of families from ${loc.name} and ${loc.nearby} who have trusted SeekersBay with their child's most important years.`,
    features: [
      "Play-based & child-centred curriculum",
      "Experienced early education teachers",
      "Safe, clean & stimulating environment",
      "Strong parent-teacher communication",
      "Creative arts, music & outdoor play",
      "Nutritious meals & healthy snacks",
    ],
    programs: [
      { icon: "🧸", title: "Toddler Program", age: "1.5–2 yrs", desc: "Gentle introduction to group learning through play, sensory activities, and social bonding." },
      { icon: "🎪", title: "Play Group",      age: "2–3 yrs",   desc: "Structured play activities that build language, motor skills, and early social skills." },
      { icon: "🎨", title: "Nursery",          age: "3–4 yrs",   desc: "Creative exploration through arts, storytelling, and hands-on discovery activities." },
      { icon: "📚", title: "Jr. KG",           age: "4–5 yrs",   desc: "Foundation literacy and numeracy with phonics, number sense, and critical thinking." },
      { icon: "🔬", title: "Sr. KG",           age: "5–6 yrs",   desc: "School-readiness programme with advanced concepts, life skills, and confidence building." },
    ],
    faq: (loc) => [
      { q: `Which is the best preschool in ${loc.name}?`,
        a: `SeekersBay is widely regarded as the best preschool in ${loc.name}, Bangalore. We are rated 4.9/5 by over 250 parents and recognised as one of Bangalore's Top 10 Preschools.` },
      { q: `What is the admission process for SeekersBay near ${loc.name}?`,
        a: `You can book a free school visit via our website or call us at +91-7618759333. Our admissions team will guide you through the process and available batches.` },
      { q: `What age groups do you accept?`,
        a: `We accept children from 1.5 years to 6 years across Toddler, Play Group, Nursery, Jr. KG, and Sr. KG programmes.` },
      { q: `Is SeekersBay close to ${loc.name}?`,
        a: `Yes! SeekersBay is conveniently accessible from ${loc.name} and nearby ${loc.nearby}. Contact us to confirm the nearest branch and transport options.` },
      { q: `Do you provide transport from ${loc.name}?`,
        a: `We offer transport assistance for select routes. Please contact us at +91-7618759333 for availability from ${loc.name}.` },
    ],
  },
  {
    type: "daycare",
    label: "Best Daycare",
    schemaType: "ChildCare",
    isPreschool: false,
    title:      (loc) => `Best Daycare in ${loc.name} | SeekersBay`,
    h1:         (loc) => `Best Daycare in ${loc.name}`,
    metaDesc:   (loc) => `SeekersBay is the best daycare in ${loc.name}, Bangalore. Safe, loving childcare for ages 1.5–6 years. Rated 4.9/5 by parents. Book a visit today!`,
    keywords:   (loc) => `best daycare in ${loc.name}, daycare near ${loc.name}, child care ${loc.name} Bangalore, creche ${loc.name}`,
    heroTag:    (loc) => `Trusted Daycare in ${loc.name} — Where Your Child Thrives`,
    heroSub:    (loc) => `Working parents in ${loc.name} and ${loc.nearby} rely on SeekersBay for safe, loving, full-day childcare. Your child learns, plays, and grows while you work with complete peace of mind.`,
    ctaSection: (loc) => `Trusted Daycare for ${loc.name} Families`,
    ctaSub:     (loc) => `Join families from ${loc.name} and ${loc.nearby} who trust SeekersBay for safe, nurturing full-day childcare.`,
    features: [
      "Full-day & half-day daycare options",
      "Safe, CCTV-monitored environment",
      "Qualified caregivers & trained staff",
      "Nutritious home-style meals & snacks",
      "Nap time, play, and structured learning",
      "Daily activity updates to parents",
    ],
    programs: [
      { icon: "☀️", title: "Full-Day Daycare",  age: "1.5–6 yrs", desc: "Comprehensive 8-hour care combining learning, play, meals, and rest in a safe environment." },
      { icon: "🌤️", title: "Half-Day Care",     age: "1.5–6 yrs", desc: "Flexible 4-hour sessions ideal for morning or afternoon care routines." },
      { icon: "🧸", title: "Infant Care",        age: "1.5–2 yrs", desc: "Gentle, one-on-one care for toddlers with sensory play and caregiver bonding." },
      { icon: "🎨", title: "After-School Care",  age: "3–6 yrs",   desc: "Safe, engaging after-school programme with homework help, activities, and snacks." },
      { icon: "📅", title: "Holiday Camps",      age: "2–6 yrs",   desc: "Fun, themed holiday programmes to keep children engaged during school breaks." },
    ],
    faq: (loc) => [
      { q: `Which is the best daycare in ${loc.name}?`,
        a: `SeekersBay is the most trusted daycare in ${loc.name}, Bangalore, rated 4.9/5 by parents. We provide safe, nurturing full-day and half-day childcare with experienced caregivers.` },
      { q: `What are the daycare timings near ${loc.name}?`,
        a: `We offer full-day (7:30 AM – 6:00 PM) and half-day options. Contact us at +91-7618759333 for exact timings for the ${loc.name} area.` },
      { q: `Is SeekersBay daycare safe for infants and toddlers?`,
        a: `Absolutely. Our facility is CCTV-monitored, child-proofed, and staffed with trained caregivers. We maintain a low child-to-caregiver ratio for personal attention.` },
      { q: `Do you serve children from ${loc.name} and ${loc.nearby}?`,
        a: `Yes! We welcome children from ${loc.name}, ${loc.nearby}, and surrounding localities. Reach out to check transport availability and the nearest centre.` },
      { q: `Do you provide meals at the daycare?`,
        a: `Yes, we provide nutritious, home-style meals and healthy snacks throughout the day, thoughtfully planned to support children's growth and energy levels.` },
    ],
  },
  {
    type: "preschool-near-me",
    label: "Preschool Near Me",
    schemaType: "School",
    isPreschool: true,
    title:      (loc) => `Preschool Near Me in ${loc.name} | SeekersBay`,
    h1:         (loc) => `Preschool Near Me in ${loc.name}`,
    metaDesc:   (loc) => `Find the best preschool near you in ${loc.name}. SeekersBay offers top-rated early education close to ${loc.name} and ${loc.nearby}. Call +91-7618759333.`,
    keywords:   (loc) => `preschool near me ${loc.name}, preschool near ${loc.name}, nearest preschool ${loc.name}, playschool near me ${loc.name}`,
    heroTag:    (loc) => `Your Nearest Top-Rated Preschool in ${loc.name}`,
    heroSub:    (loc) => `Stop searching "preschool near me" — SeekersBay is right here, serving ${loc.name} and ${loc.nearby}. Award-winning early education and caring teachers your child will love.`,
    ctaSection: (loc) => `The Nearest Great Preschool to ${loc.name}`,
    ctaSub:     (loc) => `Families in ${loc.name} and ${loc.nearby} don't need to search further. SeekersBay is right here, ready to welcome your child.`,
    features: (loc) => [
      `Conveniently located near ${loc.name}`,
      "Transport available from select routes",
      "Flexible timing options for working parents",
      "Play-based, child-centred curriculum",
      "Experienced & certified early educators",
      "Rated 4.9/5 by local parents",
    ],
    programs: [
      { icon: "🧸", title: "Toddler Program", age: "1.5–2 yrs", desc: "Gentle group learning through play, sensory activities, and early social bonding." },
      { icon: "🎪", title: "Play Group",      age: "2–3 yrs",   desc: "Structured play that builds language, motor skills, and early social abilities." },
      { icon: "🎨", title: "Nursery",          age: "3–4 yrs",   desc: "Creative exploration through arts, storytelling, and hands-on discovery." },
      { icon: "📚", title: "Jr. KG",           age: "4–5 yrs",   desc: "Foundation literacy and numeracy with phonics, number sense, and critical thinking." },
      { icon: "🔬", title: "Sr. KG",           age: "5–6 yrs",   desc: "School-readiness with advanced concepts, life skills, and confidence building." },
    ],
    faq: (loc) => [
      { q: `Is there a good preschool near me in ${loc.name}?`,
        a: `Yes! SeekersBay is one of the top-rated preschools nearest to ${loc.name}, Bangalore. We serve families from ${loc.name} and nearby ${loc.nearby}.` },
      { q: `How do I enrol my child at SeekersBay from ${loc.name}?`,
        a: `Simply call us at +91-7618759333 or book a free school visit online. Our team will help you choose the right programme and batch for your child.` },
      { q: `What makes SeekersBay the best preschool near ${loc.name}?`,
        a: `We are rated 4.9/5 by over 250 parents, recognised as one of Bangalore's Top 10 Preschools, and use a child-centred, play-based curriculum.` },
      { q: `Do you have transport from ${loc.name}?`,
        a: `We provide transport from select routes near ${loc.name}. Contact us to check availability for your specific area.` },
      { q: `What are the school hours?`,
        a: `Standard school hours are 8:30 AM to 12:30 PM. Extended daycare is also available from 7:30 AM to 6:00 PM for working parents.` },
    ],
  },
  {
    type: "daycare-near-me",
    label: "Daycare Near Me",
    schemaType: "ChildCare",
    isPreschool: false,
    title:      (loc) => `Daycare Near Me in ${loc.name} | SeekersBay`,
    h1:         (loc) => `Daycare Near Me in ${loc.name}`,
    metaDesc:   (loc) => `Best daycare near me in ${loc.name}, Bangalore. SeekersBay provides safe, trusted childcare close to ${loc.name} and ${loc.nearby}. Rated 4.9/5 by parents.`,
    keywords:   (loc) => `daycare near me ${loc.name}, daycare near ${loc.name}, creche near ${loc.name}, childcare near me ${loc.name}`,
    heroTag:    (loc) => `Trusted Daycare Near You in ${loc.name}`,
    heroSub:    (loc) => `Stop searching "daycare near me" — SeekersBay is your answer in ${loc.name}. Safe, loving, structured childcare for ages 1.5–6, with trained caregivers and healthy meals.`,
    ctaSection: (loc) => `The Nearest Trusted Daycare to ${loc.name}`,
    ctaSub:     (loc) => `Parents in ${loc.name} and ${loc.nearby} trust SeekersBay for safe, loving, full-day childcare. Book your free visit today.`,
    features: (loc) => [
      `Conveniently located near ${loc.name}`,
      "Full-day & half-day flexible options",
      "CCTV-monitored safe environment",
      "Experienced, trained caregivers",
      "Healthy meals & snacks included",
      "Daily photo & activity updates",
    ],
    programs: [
      { icon: "☀️", title: "Full-Day Daycare",    age: "1.5–6 yrs", desc: "8-hour care combining learning, play, meals, and rest — complete peace of mind." },
      { icon: "🌤️", title: "Half-Day Care",       age: "1.5–6 yrs", desc: "Flexible 4-hour sessions for children needing morning or afternoon care." },
      { icon: "🧸", title: "Infant Care",          age: "1.5–2 yrs", desc: "Personalised one-on-one care for toddlers with sensory play and caregiver bonding." },
      { icon: "🎨", title: "After-School Care",    age: "3–6 yrs",   desc: "Safe, engaging programme with activities, homework help, and snacks." },
      { icon: "📅", title: "Emergency Daycare",    age: "1.5–6 yrs", desc: "Flexible drop-in childcare available for emergency or short-notice situations." },
    ],
    faq: (loc) => [
      { q: `Is there a good daycare near me in ${loc.name}?`,
        a: `Yes! SeekersBay is the top-rated daycare nearest to ${loc.name}, Bangalore. We serve families in ${loc.name} and nearby ${loc.nearby} with safe, loving, full-day childcare.` },
      { q: `What are the daycare timings near ${loc.name}?`,
        a: `Our daycare runs 7:30 AM to 6:00 PM on weekdays. Half-day options are also available. Contact us at +91-7618759333 for details.` },
      { q: `Is SeekersBay daycare near ${loc.name} safe?`,
        a: `Absolutely. Our facility is CCTV-monitored, child-proofed, and staffed with trained caregivers maintaining a low child-to-caregiver ratio.` },
      { q: `Do you provide meals?`,
        a: `Yes, nutritious home-style meals and healthy snacks are included throughout the day, planned to support children's growth and energy.` },
      { q: `How do I enrol my child at the daycare nearest to ${loc.name}?`,
        a: `Call us at +91-7618759333 or book a free visit online. Our team will guide you through available options and transport from ${loc.name}.` },
    ],
  },
  {
    type: "top-preschool",
    label: "Top Preschool",
    schemaType: "School",
    isPreschool: true,
    title:      (loc) => `Top Preschool in ${loc.name} Bangalore | SeekersBay`,
    h1:         (loc) => `Top Preschool in ${loc.name}, Bangalore`,
    metaDesc:   (loc) => `Top preschool in ${loc.name}, Bangalore — SeekersBay. Ranked Bangalore's Top 10. 4.9/5 rating. Enrol your child for the best early education near ${loc.name}.`,
    keywords:   (loc) => `top preschool in ${loc.name}, top 10 preschool ${loc.name} Bangalore, best rated preschool ${loc.name}, award winning preschool ${loc.name}`,
    heroTag:    (loc) => `${loc.name}'s Top-Ranked Preschool — SeekersBay`,
    heroSub:    (loc) => `Recognised as one of Bangalore's Top 10 Preschools, SeekersBay brings world-class early education to families in ${loc.name} and ${loc.nearby}. 4.9/5 stars. 250+ happy families.`,
    ctaSection: (loc) => `${loc.name}'s Top Choice for Early Education`,
    ctaSub:     (loc) => `Join the families from ${loc.name} and ${loc.nearby} who chose Bangalore's Top 10 Preschool for their child's most important years.`,
    features: [
      "Ranked Bangalore's Top 10 Preschool",
      "4.9/5 rating from 250+ parents",
      "Award-winning child-centred curriculum",
      "2 certified teachers per 12 children",
      "CCTV-monitored safe campus",
      "Strong school-parent partnerships",
    ],
    programs: [
      { icon: "🧸", title: "Toddler Program", age: "1.5–2 yrs", desc: "Gentle group learning through play, sensory activities, and early social bonding." },
      { icon: "🎪", title: "Play Group",      age: "2–3 yrs",   desc: "Structured play that builds language, motor skills, and early social abilities." },
      { icon: "🎨", title: "Nursery",          age: "3–4 yrs",   desc: "Creative exploration through arts, storytelling, and hands-on discovery." },
      { icon: "📚", title: "Jr. KG",           age: "4–5 yrs",   desc: "Foundation literacy, phonics, number sense, and critical thinking." },
      { icon: "🔬", title: "Sr. KG",           age: "5–6 yrs",   desc: "Full school-readiness with advanced concepts, life skills, and confidence." },
    ],
    faq: (loc) => [
      { q: `Is SeekersBay really a top preschool in ${loc.name}?`,
        a: `Yes! SeekersBay is officially ranked among Bangalore's Top 10 Preschools and rated 4.9/5 by over 250 parents. Families from ${loc.name} and ${loc.nearby} regularly choose us.` },
      { q: `What makes SeekersBay a top-ranked preschool near ${loc.name}?`,
        a: `We maintain a 2-teacher-per-12-children ratio, use a proven play-based curriculum, offer CCTV-monitored safe premises, and ensure strong parent-teacher communication.` },
      { q: `How is SeekersBay different from other preschools near ${loc.name}?`,
        a: `We focus on holistic development — emotional, social, physical, and cognitive — not just academics. Our award-winning approach produces confident, curious, happy learners.` },
      { q: `How do I visit the top preschool near ${loc.name}?`,
        a: `Call +91-7618759333 or book a free school visit on our website. We'll show you around and answer all your questions.` },
      { q: `What awards has SeekersBay received?`,
        a: `SeekersBay has been recognised as one of Bangalore's Top 10 Preschools and maintains a 4.9/5 rating based on 250+ Google reviews from parents across Bangalore.` },
    ],
  },
];

export const TESTIMONIALS = [
  { name: "CHANDRAWALI KALITA", role: "Parent", stars: 5, quote: "School is good. All the members understand our issues and try to resolve if any. Mainly takes good care of my kids." },
  { name: "CS Reddy",           role: "Parent", stars: 5, quote: "Seekers Bay Pre-School is a wonderful place for kids to learn and grow. The teachers are caring, patient, and always supportive." },
  { name: "Sanchit Pandey",     role: "Parent", stars: 5, quote: "We are really happy with the school's balanced approach towards academics and extracurricular activities. The curriculum is thoughtfully designed." },
  { name: "Ravindra Patel",     role: "Parent", stars: 5, quote: "A big thank you to the whole team! The activities are creative and engaging, helping children build confidence and skills in a fun way." },
];
